import React, { useState, useEffect } from "react";

import { mapOfferToCard } from "./utils/OfferMapping";
import { Link } from "react-router-dom";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import {
  getOthersOffers,
  getMyOffers,
  getSavedOffers,
  getOfferByIds,
} from "services/offer_service";

import { deleteSaveOffer } from "services/offer_service";
import OfferCard from "components/team/OfferCard";

function App() {
  const [myOffers, setMyOffers] = useState([]);
  const [savedOffersList, setSavedOffersList] = useState([]);
  const [savedOfferMaps, setSavedOfferMaps] = useState(new Map()); // map containing offerId => offer Saved ID

  useEffect(() => {
    async function fetchData() {
      await fetchDataAsync();
    }

    fetchData();
  }, []);

  const fetchDataAsync = async () => {
    let games = await getOthersOffers();
    let myOffers = await getMyOffers();

    games.sort((a, b) => {
      return new Date(a.attributes.date) - new Date(b.attributes.date);
    });

    games.sort((a, b) => {
      return new Date(a.attributes.date) - new Date(b.attributes.date);
    });

    myOffers = mapOfferToCard(myOffers);
    setMyOffers(myOffers);

    const savedOffers = await getSavedOffers();

    if (savedOffers.size > 0) {
      let savedOffersArray = [];
      for (var [key] of savedOffers) {
        savedOffersArray.push(key);
      }

      let savedOffList = await getOfferByIds(savedOffersArray);

      setSavedOfferMaps(savedOffers);
      let myOffersListMap = mapOfferToCard(savedOffList);
      setSavedOffersList(myOffersListMap);
    }
  };

  const canAddOffer = () => {
    if (localStorage.getItem("role") === "Clube") {
      return true;
    }

    return false;
  };

  const removeSavedOffer = async (id) => {
    await deleteSaveOffer(savedOfferMaps.get(id));
    savedOfferMaps.delete(id);

    let saveOffer = savedOffersList.filter((el) => el.id !== id);
    setSavedOffersList(saveOffer);

    await fetchDataAsync();
    return;
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/ofertas"}>Vagas</Link>
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">
                      {localStorage.getItem("role") === "Clube"
                        ? "As minhas vagas:"
                        : "Vagas que eu me candidatei"}{" "}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="columns" style={{ display: "block" }}>
              {myOffers?.length > 0 &&
                myOffers.map((el) => (
                  <>
                    <OfferCard
                      id={el.id}
                      createdDate={el.createdAt}
                      title={el.title}
                      subTitle={el.subTitle}
                      division={el.division}
                      savedOfferId={savedOfferMaps.get(el.id)}
                      removeSaveOffer={async () =>
                        await removeSavedOffer(el.id)
                      }
                      changeOffers={async () =>
                        await fetchDataAsync()
                      }
                    ></OfferCard>
                  </>
                ))}
            </div>
            {canAddOffer() && (
              <div className="fullwidth flex">
                <Link to={`/ofertas/nova-oferta`} className="marginAuto">
                  <i className="fa fa-plus circled-icon"></i>
                </Link>
              </div>
            )}
            <br></br>
            <br></br>
            <br></br>
            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Vagas Guardadas</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="columns" style={{ display: "block" }}>
              {savedOffersList?.length > 0 &&
                savedOffersList.map((el) => (
                  <>
                    <OfferCard
                      id={el.id}
                      createdDate={el.createdAt}
                      title={el.title}
                      subTitle={el.subTitle}
                      division={el.division}
                      savedOfferId={savedOfferMaps.get(el.id)}
                      removeSaveOffer={async () =>
                        await removeSavedOffer(el.id)
                      }
                      changeOffers={async () =>
                        await fetchDataAsync()
                      }
                    ></OfferCard>
                  </>
                ))}
            </div>
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
